
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5506',
  depVersions: {
  "data-privacy-request-ui": "static-1.5506",
  "data-fetching-client": "static-1.9649",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.7993",
  "hub-http-shared-msw-handlers": "static-1.9903",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11446",
  "I18n": "static-7.1617",
  "jasmine-runner": "static-1.6445",
  "privacy-center-public-service-types": "static-1.4769",
  "quartz": "static-1.6998",
  "react-dlb": "static-1.78",
  "ui-components-test-utils": "static-1.5583",
  "UIComponents": "static-3.8392",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.85",
  "foundations-assets": "static-1.4842",
  "foundations-components": "static-1.7885",
  "foundations-components-test-utils": "static-1.5368",
  "foundations-theming": "static-1.4397",
  "hub-http": "static-1.6200",
  "quartz-config": "static-1.776",
  "quartz-core": "static-1.6217",
  "quartz-routing": "static-1.428",
  "quick-fetch": "static-1.3897",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-rhumb": "static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11130",
  "usage-tracker": "static-1.7323",
  "usage-tracker-anonymous": "static-1.5740",
  "usage-tracker-core": "static-1.7173",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4115",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3385",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3275",
  "quartz-webpack": "static-1.3222",
  "bend-plugin-quartz-routing": "static-1.76",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "HeadJS": "static-2.754",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3104",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "ts-schema": "static-1.4062",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "react-utils": "static-2.5325",
  "StyleGuideUI": "static-3.486",
  "jasmine": "static-4.4305",
  "rpc-client-utils": "static-1.4630",
  "HubStyle": "static-2.11753",
  "ui-addon-draggable": "static-3.4746",
  "cssUtils": "static-1.786",
  "hs-story-utils": "static-1.9406",
  "icons": "static-2.644",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1147",
  "bend-plugin-foundations-components": "static-1.4154",
  "floating-ui": "static-1.55",
  "foundations-theming-specialty": "static-1.2113",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1805",
  "ui-fonts": "static-1.708",
  "foundations-components-legacy": "static-1.910",
  "bend-plugin-foundations-theming": "static-1.2880",
  "foundations-theming-base": "static-1.3382",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.66",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4634",
  "mobile-manifest-mixins": "static-1.529",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.673",
  "quartz-head": "static-1.663",
  "quartz-i18n": "static-1.673",
  "quartz-test": "static-1.673",
  "quartz-tracking": "static-1.377",
  "usage-tracker-container": "static-1.7313",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3171",
  "bend-plugin-chirp-manifest": "static-1.40",
  "chirp-fetch": "static-1.1865",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.69",
  "sassPrefix": "static-1.155",
  "hubspotter-http-shared-msw-handlers": "static-1.9901",
  "usage-tracker-session-replay": "static-1.5009",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5506",
  "data-fetching-client": "/data-fetching-client/static-1.9649",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.7993",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9903",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11446",
  "I18n": "/I18n/static-7.1617",
  "jasmine-runner": "/jasmine-runner/static-1.6445",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4769",
  "quartz": "/quartz/static-1.6998",
  "react-dlb": "/react-dlb/static-1.78",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5583",
  "UIComponents": "/UIComponents/static-3.8392",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "foundations-assets": "/foundations-assets/static-1.4842",
  "foundations-components": "/foundations-components/static-1.7885",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5368",
  "foundations-theming": "/foundations-theming/static-1.4397",
  "hub-http": "/hub-http/static-1.6200",
  "quartz-config": "/quartz-config/static-1.776",
  "quartz-core": "/quartz-core/static-1.6217",
  "quartz-routing": "/quartz-routing/static-1.428",
  "quick-fetch": "/quick-fetch/static-1.3897",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11130",
  "usage-tracker": "/usage-tracker/static-1.7323",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5740",
  "usage-tracker-core": "/usage-tracker-core/static-1.7173",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3385",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3275",
  "quartz-webpack": "/quartz-webpack/static-1.3222",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.76",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "HeadJS": "/HeadJS/static-2.754",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3104",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "ts-schema": "/ts-schema/static-1.4062",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "react-utils": "/react-utils/static-2.5325",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "jasmine": "/jasmine/static-4.4305",
  "rpc-client-utils": "/rpc-client-utils/static-1.4630",
  "HubStyle": "/HubStyle/static-2.11753",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4746",
  "cssUtils": "/cssUtils/static-1.786",
  "hs-story-utils": "/hs-story-utils/static-1.9406",
  "icons": "/icons/static-2.644",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1147",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4154",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2113",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1805",
  "ui-fonts": "/ui-fonts/static-1.708",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.910",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2880",
  "foundations-theming-base": "/foundations-theming-base/static-1.3382",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.66",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4634",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.529",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.673",
  "quartz-head": "/quartz-head/static-1.663",
  "quartz-i18n": "/quartz-i18n/static-1.673",
  "quartz-test": "/quartz-test/static-1.673",
  "quartz-tracking": "/quartz-tracking/static-1.377",
  "usage-tracker-container": "/usage-tracker-container/static-1.7313",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.40",
  "chirp-fetch": "/chirp-fetch/static-1.1865",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.69",
  "sassPrefix": "/sassPrefix/static-1.155",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9901",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5009",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
